/**
 * Lordicon System/Regular icon mapping.
 * All icons downloaded from lordicon.com/icons/system/regular
 * Files stored in /public/lordicons/ as Lottie JSON.
 *
 * To add more icons, run the decode_li.py script or go to:
 * https://lordicon.com/icons/system/regular and download → Lottie JSON
 *
 * Trigger options: 'hover' | 'click' | 'loop' | 'loop-on-hover' | 'in' | 'morph' | 'boomerang'
 */

const LORDICONS: Record<string, string> = {
  // ─── Navigation & UI ────────────────────────────────────────────────────
  dashboard:    '/lordicons/dashboard.json',      // system-regular-24-view-1
  calendar:     '/lordicons/calendar.json',        // system-regular-23-calendar
  bell:         '/lordicons/bell.json',            // system-regular-46-notification-bell
  chat:         '/lordicons/chat.json',            // system-regular-47-chat
  users:        '/lordicons/users.json',           // system-regular-96-groups
  user:         '/lordicons/avatar.json',          // Avatar (replaces old account icon)
  person:       '/lordicons/avatar.json',          // alias → Avatar
  avatar:       '/lordicons/avatar.json',          // system Avatar (8-account)
  building:     '/lordicons/building.json',        // system-regular-73-world-globe
  document:     '/lordicons/document.json',        // system-regular-50-file
  settings:     '/lordicons/settings.json',        // system-regular-63-settings-cog
  logout:       '/lordicons/logout.json',          // system-regular-112-log-sign-out
  login:        '/lordicons/login.json',           // system-regular-113-log-sign-in
  list:         '/lordicons/list.json',            // system-regular-171-view-list
  history:      '/lordicons/history.json',         // system-regular-141-history
  briefcase:    '/lordicons/briefcase.json',       // system-regular-178-work
  clipboard:    '/lordicons/clipboard.json',       // system-regular-17-assignment
  clock:        '/lordicons/clock.json',           // system-regular-67-clock
  search:       '/lordicons/search.json',          // system-regular-42-search
  home:         '/lordicons/home.json',            // system-regular-41-home
  info:         '/lordicons/info.json',            // system-regular-28-info
  pin:          '/lordicons/pin.json',             // system-regular-89-location
  location:     '/lordicons/location.json',        // system-regular-86-pin

  // ─── Actions ────────────────────────────────────────────────────────────
  check:        '/lordicons/check.json',           // system-regular-31-check
  cross:        '/lordicons/cross.json',           // system-regular-29-cross
  plus:         '/lordicons/plus.json',            // system-regular-314-plus
  edit:         '/lordicons/edit.json',            // system-regular-114-edit-pencil
  trash:        '/lordicons/trash.json',           // system-regular-39-trash
  upload:       '/lordicons/upload.json',          // system-regular-80-upload
  download:     '/lordicons/download.json',        // system-regular-81-download-save
  lock:         '/lordicons/lock.json',            // system-regular-90-lock-closed
  eye:          '/lordicons/eye.json',             // system-regular-92-visibility
  arrow:        '/lordicons/arrow-right.json',     // system-regular-506-arrow-right

  // ─── Finance & Business ─────────────────────────────────────────────────
  money:        '/lordicons/money.json',           // system-regular-115-money-cash
  wallet:       '/lordicons/wallet.json',          // system-regular-5-wallet
  credit:       '/lordicons/credit.json',          // system-regular-38-credit-card

  // ─── Status ─────────────────────────────────────────────────────────────
  error:        '/lordicons/error.json',           // system-regular-55-error
  warning:      '/lordicons/warning.json',         // system-regular-56-warning
  star:         '/lordicons/star.json',            // system-regular-95-star
  cloud:        '/lordicons/cloud.json',           // system-regular-84-cloud

  // ─── Communication ──────────────────────────────────────────────────────
  email:        '/lordicons/email.json',           // system-regular-59-email
  phone:        '/lordicons/phone.json',           // system-regular-58-call-phone

  // ─── Analytics ──────────────────────────────────────────────────────────
  analytics:    '/lordicons/analytics.json',       // system-regular-10-analytics
  chart:        '/lordicons/chart.json',           // system-regular-16-assessment
  build:        '/lordicons/build.json',           // system-regular-22-build
};

export default LORDICONS;

/**
 * Known animation states per icon for use with the `state` prop:
 *
 * calendar:  hover-calendar | in-calendar | morph-calendar
 * bell:      hover-bell | in-bell | loop-bell
 * chat:      hover-chat | in-chat
 * users:     hover-groups | in-groups | morph-group-single
 * user:      hover-account | in-account
 * settings:  hover-cog-1 | hover-cog-2 | in-cog
 * logout:    hover-log-out | in-log-out
 * login:     hover-sign-in | in-sign-in
 * clock:     hover-clock | in-clock | loop-clock
 * trash:     hover-trash-empty | in-trash-empty | morph-trash-full
 * history:   hover-history | in-history | loop-history
 * check:     hover-pinch | in-reveal | morph-select:0.5
 * cross:     hover-cross-1 | hover-cross-2 | in-cross
 * edit:      hover-pinch | in-reveal
 * bell:      hover-bell | loop-bell
 */
